import "../../../editor/nodeflight/fonts/editorFonts.css"
import "../../../editor/nodeflight/fonts/fallbackFonts.css"
import "./speedyg.css"
import { Base64 } from 'js-base64'

import { SpeedyGApp } from "./SpeedyGApp"

async function run() {
  const uiElems = {
    appBody: document.getElementById("appBody"),
    embedContainer: document.getElementById("embedContainer"),
    embedIframe: document.getElementById("embedIframe"),
    svgContainer: document.getElementById("svgContainer"),
    svgContainerHeader: document.getElementById("svgContainerHeader"),
    mainPage: document.getElementById("mainPage"),
    pagesContainer: document.getElementById("pagesContainer"),
    fullScreenButton: document.getElementById("fullScreenButton"),
    playButton: document.getElementById("playButton"),
    printButton: document.getElementById("printButton"),
    printButtonContainer: document.getElementById("printButtonContainer"),
    playbackButton: document.getElementById("playbackButton"),
    scoreButton: document.getElementById("scoreButton"),
    pageTurnerBack: document.getElementById("pageTurnerBack"),
    pageTurnerForward: document.getElementById("pageTurnerForward"),
    spinner: document.getElementById("spinner"),
    overlayCaption: document.getElementById("overlayCaption"),
  }
  const config = JSON.parse(Base64.decode(appConfigJsonB64))
  const app = new SpeedyGApp(config, uiElems)

  app.start()
}

window.addEventListener("load", run)

